export default "__VITE_ASSET__sbRcElJL__"